<template>
<div>
   <b-modal :id="ModalId" size="lg" :no-close-on-backdrop="true" :no-close-on-esc="true" @hide="hideModal" ok-only :ok-title="$t('Shared.Close')" centered :title="TitleWindow" :visible="true" @ok="this.emitEventOK">
   <div id="ContainerEmpInbModalDischarge" class="row">
        <div class="col">
            <Discharge v-bind:RecordId="this.RecordId" v-bind:PatientCode="this.PatientCode" v-bind:HideDoc="true" />
        </div>
    </div>
  </b-modal>
 </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import Discharge from '@/components/pages/Discharge/discharge.vue'


export default {
  name: 'EmployeeInboxDischargeModal', 
  mixins: [ShowMessage, DBFunctions],
  components:{Discharge},
  props: {
      TitleWindow : String,   
      RecordId:String,
      PatientCode:String,    
   },
  data() {
    return {
       parameter:{
        SearchCriteria:'',
        PageNumber : 0,
        PageSize:999 ,
        TestCode:'',
        SectionCode:''             
      },
      ModalId: 'EmpInboxModalDischarge',
      changesPending: false,      
    }
  },

  methods: {
      emitEventOK(/*bvModalEvent*/) {
        EventBus.$emit('CloseMdNote');
      },

      hideModal(){
        EventBus.$emit('CloseMdNote');
      }
  },

  created () {
    /*EventBus.$on("onControlWasChanged", function () { 
      this.changesPending = true
     }.bind(this));

     EventBus.$on("onChanged", function () { 
      this.changesPending = true
     }.bind(this));

     EventBus.$on("updateChangesIWF", function () { 
        this.changesPending = false
     }.bind(this));

     EventBus.$on("showSummary", function (data) { 
        this.showIWFSummary = data
     }.bind(this));*/
  },

  beforeDestroy() {
    EventBus.$emit('CloseMdNote');
    EventBus.$off('onControlWasChanged');
    EventBus.$off('onChanged');
    EventBus.$off('updateChangesIWF');
    EventBus.$off('showSummary');

    this.$root.$off("bv::modal::shown", null);
  },
};

</script>
<style>
  #IWFModal___BV_modal_body_ {
    padding: 5px;
   
  }

  #IWFModal{
    margin-top:42px;
  }
</style>